<template>
  <!-- <div class="errorPage animated">
      <div class="errorPageContainer">
          <div class="errorPageContent animated">
              <div class="white--text title font-weight-regular">Oops! Page not found.</div>
              <h1 class="blue-text ls-1px">404</h1>
              <p class="white--text font-weight-regular">We cannot find the page you are looking for</p>
              <v-btn style="background:#fff !important;" class="blue-text" @click="naviagateToLogin">GO BACK HOME</v-btn>
          </div>
      </div>
    </div> -->

  <!-- <div class="errorPage animated">
      <div class="d-flex align-items-center" style="height: 100vh; justify-content: space-evenly;">
          <div class="mr-4">
               <img src="../../assets/403.svg" alt="403" width="500"/>
          </div>
          <div class="errorPageContent animated" style="width: 500px; text-align: center;">
              <h5 class="title font-weight-regular">YOU SHALL NOT PASS</h5>
              <h1 class="blue-text ls-1px">403</h1>
              <h5 class="title blue-text font-weight-regular mb-4">ACCESS DENIED</h5>
              <p class="font-weight-regular">We are sorry, but you do not have <br> access to this page without connecting <span class="font-weight-bold blue-text">VPN</span>.</p>
              <v-btn class="btn btn__primary" @click="naviagateToLogin">Refresh</v-btn>
          </div>
      </div>
    </div> -->

  <div class="errorPage animated">
    <div
      class="d-flex align-items-center"
      style="height: 100vh; justify-content: space-evenly;"
    >
      <div class="mr-4">
        <img src="../../assets/404.svg" alt="404" width="500" />
      </div>
      <div
        class="errorPageContent animated"
        style="width: 500px; text-align: center;"
      >
        <h5 class="title font-weight-regular">OOPS! THERE'S NOTHING HERE</h5>
        <h1 class="blue-text ls-1px">404</h1>
        <h5 class="title blue-text font-weight-regular mb-4">PAGE NOT FOUND</h5>
        <p class="font-weight-regular">
          We cannot find the page you are looking for doesn't exist.
        </p>
        <v-btn class="btn btn__primary" @click="naviagateToLogin"
          >Go Back</v-btn
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PageNotFound",
  methods: {
    naviagateToLogin() {
      this.$router.push({ path: "/dashboard" });
    },
  },
};
</script>

<style scoped>
.errorPageContainer {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  padding: 30px;
}
.errorPageContent {
  opacity: 0;
  animation-name: fadeInUp;
}
.errorPage {
  height: 100vh;
  /* background:#0a3246 !important; */
  padding: 1rem;
}
.text {
  font-size: 7rem;
  text-align: center !important;
}
.ls-1px {
  letter-spacing: 1px;
}
.mt-1rem {
  margin-top: 1rem !important;
}
.mb-1rem {
  margin-bottom: 1rem !important;
}
.errorPageContent h1 {
  font-size: 160px;
  font-weight: 900;
  letter-spacing: 20px;
  /* font-family: 'Open Sans', sans-serif; */
  font-family: 'Manrope', sans-serif;
}
.errorPageContent p {
  letter-spacing: 0.4px !important;
}
/* .blue-text{
    color: #21ce99 !important;
} */
@keyframes fadeInUp {
  from {
    transform: translate3d(0, 40px, 0);
  }
  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

.animated {
  animation-duration: 2s;
  animation-fill-mode: both;
}

.animatedFadeInUp {
  opacity: 0;
}

.fadeInUp {
  opacity: 0;
  animation-name: fadeInUp;
  -webkit-animation-name: fadeInUp;
}
</style>
